import { takeEvery, put, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import { isResponseFailed } from 'helpers/responseHelpers'
import { getInfoFromHash } from 'store/entities/router/selectors'
import { sendError } from 'store/entities/analytics/actions'
import { ERRORS } from 'store/entities/analytics/consts'
import { fetchReviewsReport, processReportsQuery } from 'store/entities/reviews/actions'

function* processReportsHandler() {
  try {
    // example link "organizationId=2&userId=22&reviewType=t1"
    const query = yield select(getInfoFromHash)
    const organizationId = query.organizationId
    const userId = query.userId
    const reviewType = query.reviewType
    if (!query || !organizationId || !userId || !reviewType) {
      yield put(push('/'))
      return
    }

    const response = yield fetchReviewsReport.call({ organizationId, userId, reviewType })
    if (isResponseFailed(response)) {
      throw response
    }
    yield put(push('/reports'))
  } catch (error) {
    yield put(
      sendError({
        type: ERRORS.PROCESS_REPORTS_QUERY,
        error,
      })
    )
    yield put(push('/'))
  }
}

export default function* processReportsHandlerSaga() {
  yield takeEvery(processReportsQuery.toString(), processReportsHandler)
}
